import { api } from './api';

/**
 * Modelo de imagem que a equipe interna pode fixar ao regerar.
 * Espelha `config/image-providers.php > providers.*.available_models` — a mesma
 * lista que o módulo de provider-chains usa.
 */
export interface GenerationModelOption {
    id: string;
    label: string;
    provider: string;
}

export const generationModelsService = {
    /**
     * Devolve lista VAZIA para quem não é da Snapfy (o backend decide, não 403).
     * O chamador só renderiza o seletor quando vem algo, então "não é para você"
     * e "nenhum modelo habilitado" caem no mesmo caso.
     */
    list: async (): Promise<GenerationModelOption[]> => {
        const response = await api.get<{ data: GenerationModelOption[] }>('/generation-models');
        return response.data?.data ?? [];
    },
};
